"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var create_flags_1 = require("./create-flags");

exports.createFlags = create_flags_1.createFlags;
exports.default = create_flags_1.createFlags;